import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import Loader from 'react-loader-spinner';
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import moment from 'moment'
import { baseUrl } from '../../../config';
import axiosIntance from '../../../helper/axios';
import { checkAccess, FEATURES } from '../../../library/auth'
import {clickColor,inArray,renderCurrency,renderDate} from '../../../library/util';
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';

function RevboostChargebackDetail() {

  const history = useHistory();
  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null ||
      !checkAccess(FEATURES.revboost_report)) {
    history.push('/')
  }

  const [reportData,setReportData]=useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedrowList,setSelectedRowList]=useState([]);
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23,59,0,0));
  const [message, setMessage] = useState('')
  const [loader,setLoader]=useState(false);

  useEffect(() => {
    return () => {
      console.log('un subscribe')
    }
  }, []);

  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  const handleSelectRow = (selectedRow) => {
    if (!inArray(selectedRow.tableData.id, selectedrowList)) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }

  const handleRunReport = () => {
    setMessage('');

    if (startDate == null) {
      setMessage('Date must not be blank')
      return false;
    }

    setLoader(true);

    axiosIntance.get(`${baseUrl}/reports/revboost/revboostchargebackdetail`
      + `?startdate=${moment(startDate).format('YYYY-MM-DD HH:mm:ss')}`
      + `&enddate=${moment(endDate).format('YYYY-MM-DD HH:mm:ss')}`
    , {}).then(response => {
      setLoader(false);
      if (response.data.result.length > 0) {
        setReportData(response.data.result);
      } else {
        setReportData([]);
      }
    }).catch(error => {
      setLoader(false);
      setMessage('Something went wrong');
    });
  }

  const handleResetFilter = () => {
    setMessage('');
    setEndDate(new Date(Date.now()));
    setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    setReportData([]);
  }

  // const renderPercent = field => data => 
  //   data[field] !== undefined ? `${(100 * data[field]).toFixed(1)}%`  : '';

  // const renderCurrency = field => data => 
  //   data[field] !== undefined ? `$${data[field].toFixed(2)}`  : '';

  return (
    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

      <div className='errorMsg'>{message}</div>

      <section id="content-wrapper">
        <label>Start Date</label>
        <label className='endDateStyle'>End Date</label>
        {/* <label style={{marginLeft: '100px'}}>Group By</label> */}
        <div className="input-bar">
          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={startDate}
              className='width140x'
              onChange={(date) => setStartDate(date)}
              placeholder='Start Date'
              showTimeSelect={false}
            />

          </div>

          &nbsp;&nbsp;&nbsp;

          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd"
              selected={endDate}
              className='width140x'
              onChange={(date) => setEndDate(date)}
              placeholder='End Date'

              showTimeSelect={false}
            />

          </div>

          &nbsp;&nbsp;&nbsp;
        
          <div className="input-bar-item">
            <button type="button" onClick={handleRunReport} className="btn btn-primary">Run Report</button>
          </div>

          <div className='input-bar-item'>
            <button type="button" onClick={handleResetFilter} className="btn btn-primary">Reset</button>
          </div>

        </div>

        {loader

          ? <div className='loaderDiv'>
            <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" />
          </div>
          
          : <MaterialTable
            // onRowClick={((evt, selectedRow) => handleSelectRow(selectedRow))}

            columns={[
              { title: "Custom Name", field: "group" },
              { title: "CB Amount", field: "cb_amount", render: renderCurrency('cb_amount') },
              { title: "FE CBs", field: "cb_fes" },
              { title: "Upsell CBs", field: "cb_upsells" },
              { title: "VIP Upsell CBs", field: "cb_vip_upsells" },
              { title: "VIP Rebill CBs", field: "cb_vip_rebills" },
              { title: "Number of Days Between Last Transaction and CB", field: "last_trx_date_last_cb_date_delta" },
              { title: "Last Transaction Date", field: "last_trx_date" },
              { title: "Last CB Date", field: "last_cb_date" },
            ]}

            data={reportData}

            parentChildData={(row, rows) => rows.find(r => r.key === row.parentKey)}

            title="Revboost Chargeback Detail"

            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              maxBodyHeight: '560px',
              paging: false,
              exportButton: true,
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : '',
              }),
            }}
          />
        }

      </section>

    </div>
  );
}

export default RevboostChargebackDetail
